<template>
  <div
    class="flex min-h-screen items-center justify-center bg-background p-5"
  >
    <Head title="Error" />
    <Card class="w-full max-w-md">
      <CardHeader>
        <div class="flex items-start justify-between">
          <div class="flex items-center space-x-2">
            <div class="flex h-8 w-8 items-center justify-center rounded-full bg-destructive">
              <svg class="h-4 w-4 text-destructive-foreground" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z" />
              </svg>
            </div>
            <CardTitle class="text-xl">
              {{ title }}
            </CardTitle>
          </div>
          <Button 
            variant="ghost" 
            size="sm" 
            @click="handleClose"
            class="h-8 w-8 p-0"
          >
            <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
            <span class="sr-only">Close</span>
          </Button>
        </div>
      </CardHeader>
      <CardContent>
        <p class="text-muted-foreground">
          {{ description }}
        </p>
        <div v-if="retryAfter" class="mt-2 text-sm text-muted-foreground">
          Please wait {{ retryAfter }} seconds before trying again.
        </div>
      </CardContent>
      <CardFooter>
        <Button @click="handleClose" class="w-full">
          Close
        </Button>
      </CardFooter>
    </Card>
  </div>
</template>

<script setup>
import { Head, router } from '@inertiajs/vue3'
import { computed } from 'vue'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from '@/components/ui/card'

const props = defineProps({
  message: String,
  status: Number,
  retry_after: [Number, String]
})

const title = computed(() => {
  return {
    503: 'Service Unavailable',
    500: 'Server Error', 
    404: 'Page Not Found',
    403: 'Forbidden',
    429: 'Too Many Attempts'
  }[props.status] || 'Unexpected Error'
})

const description = computed(() => {
  return {
    503: 'Sorry, we are doing some maintenance. Please check back soon.',
    500: 'Whoops, something went wrong on our servers.',
    404: 'Sorry, the page you are looking for could not be found.',
    403: 'Sorry, you are forbidden from accessing this page.',
    429: 'You have made too many requests. Please wait before trying again.'
  }[props.status] || props.message || 'An unexpected error occurred.'
})

const retryAfter = computed(() => {
  return props.retry_after
})

const handleClose = () => {
  // Go back to previous page, or home if no history
  if (window.history.length > 1) {
    window.history.back()
  } else {
    router.visit('/')
  }
}
</script>
